import { jsxs, jsx } from "react/jsx-runtime";
import { useMemo, useState } from "react";
const toNum = (v) => {
  if (v != null && typeof v === "object" && "value" in v) return Number(v.value);
  return Number(v);
};
const DevInfoPanel = ({ devInfo }) => {
  const isDevMode = useMemo(
    () => new URLSearchParams(window.location.search).get("isDev") === "true",
    []
  );
  const [expanded, setExpanded] = useState(false);
  if (!isDevMode) return null;
  const { devOptions, effectiveRankingWeights } = devInfo;
  const baseWeights = devOptions.rankingWeights;
  const WeightRow = ({
    label,
    base,
    effective
  }) => {
    const b = toNum(base);
    const e = toNum(effective);
    const delta = e - b;
    const hasChange = Math.abs(delta) > 1e-3;
    return /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", gap: "6px", fontSize: "12px" }, children: [
      /* @__PURE__ */ jsx("span", { style: { minWidth: "70px", color: "#666" }, children: label }),
      /* @__PURE__ */ jsx("span", { style: { minWidth: "38px", textAlign: "right", fontVariantNumeric: "tabular-nums", color: "#999" }, children: b.toFixed(2) }),
      /* @__PURE__ */ jsx("span", { style: { color: "#999", fontSize: "11px" }, children: "→" }),
      /* @__PURE__ */ jsx(
        "span",
        {
          style: {
            minWidth: "38px",
            textAlign: "right",
            fontVariantNumeric: "tabular-nums",
            fontWeight: 600,
            color: hasChange ? "#2563eb" : "#444"
          },
          children: e.toFixed(2)
        }
      ),
      hasChange && /* @__PURE__ */ jsxs(
        "span",
        {
          style: {
            fontSize: "11px",
            color: delta > 0 ? "#16a34a" : "#dc2626",
            fontVariantNumeric: "tabular-nums"
          },
          children: [
            "(",
            delta > 0 ? "+" : "",
            delta.toFixed(2),
            ")"
          ]
        }
      )
    ] });
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      style: {
        border: "1px solid #e5e7eb",
        borderRadius: "8px",
        overflow: "hidden",
        marginBottom: "8px",
        background: "#fefce8"
      },
      children: [
        /* @__PURE__ */ jsxs(
          "button",
          {
            onClick: () => setExpanded((prev) => !prev),
            style: {
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
              padding: "6px 12px",
              background: "transparent",
              border: "none",
              cursor: "pointer",
              fontSize: "12px",
              color: "#92400e",
              fontWeight: 500
            },
            children: [
              /* @__PURE__ */ jsx("span", { children: "Search Dev Info" }),
              /* @__PURE__ */ jsx("span", { style: { fontSize: "11px" }, children: expanded ? "▲" : "▼" })
            ]
          }
        ),
        expanded && /* @__PURE__ */ jsxs(
          "div",
          {
            style: {
              padding: "10px 12px",
              fontSize: "12px",
              color: "#555",
              display: "flex",
              flexDirection: "column",
              gap: "12px",
              borderTop: "1px solid #e5e7eb",
              background: "#fffef5"
            },
            children: [
              /* @__PURE__ */ jsxs("div", { style: { display: "flex", flexWrap: "wrap", gap: "16px", alignItems: "center" }, children: [
                /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", gap: "6px" }, children: [
                  /* @__PURE__ */ jsx("span", { style: { color: "#666", fontWeight: 500 }, children: "Recall:" }),
                  /* @__PURE__ */ jsx(
                    "span",
                    {
                      style: {
                        padding: "2px 8px",
                        borderRadius: "4px",
                        border: "1px solid",
                        borderColor: devOptions.useTextRecall ? "#2563eb" : "#16a34a",
                        backgroundColor: devOptions.useTextRecall ? "#eff6ff" : "#f0fdf4",
                        color: devOptions.useTextRecall ? "#2563eb" : "#16a34a",
                        fontSize: "11px",
                        fontWeight: 600
                      },
                      children: devOptions.useTextRecall ? "Text" : "KNN"
                    }
                  )
                ] }),
                /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", gap: "6px" }, children: [
                  /* @__PURE__ */ jsx("span", { style: { color: "#666", fontWeight: 500 }, children: "Page size:" }),
                  /* @__PURE__ */ jsx("span", { style: { fontWeight: 600, color: "#333" }, children: toNum(devOptions.pageSize) })
                ] })
              ] }),
              /* @__PURE__ */ jsxs("div", { style: { display: "flex", flexDirection: "column", gap: "4px" }, children: [
                /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", gap: "8px", marginBottom: "2px" }, children: [
                  /* @__PURE__ */ jsx("span", { style: { color: "#666", fontWeight: 500 }, children: "Ranking weights" }),
                  /* @__PURE__ */ jsx("span", { style: { fontSize: "11px", color: "#999" }, children: "(base → effective)" })
                ] }),
                /* @__PURE__ */ jsx(WeightRow, { label: "semantic", base: baseWeights.semanticWeight, effective: effectiveRankingWeights.semanticWeight }),
                /* @__PURE__ */ jsx(WeightRow, { label: "sales", base: baseWeights.salesWeight, effective: effectiveRankingWeights.salesWeight }),
                /* @__PURE__ */ jsx(WeightRow, { label: "content", base: baseWeights.contentWeight, effective: effectiveRankingWeights.contentWeight }),
                /* @__PURE__ */ jsx(WeightRow, { label: "review", base: baseWeights.reviewWeight, effective: effectiveRankingWeights.reviewWeight }),
                /* @__PURE__ */ jsx(WeightRow, { label: "reward", base: baseWeights.rewardWeight, effective: effectiveRankingWeights.rewardWeight }),
                /* @__PURE__ */ jsx(WeightRow, { label: "price", base: baseWeights.priceWeight, effective: effectiveRankingWeights.priceWeight })
              ] })
            ]
          }
        )
      ]
    }
  );
};
export {
  DevInfoPanel as default
};
//# sourceMappingURL=DevInfoPanel.js.map
